module.exports = __webpack_public_path__ + "static/img/electric.d8035c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/electric.png
// module id = zYG4
// module chunks = 1